import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModLoadData {
  gdam: any[];
  dam: any[];
  demand: any[];
  rtm: any[];
  dailyAverage: any[];
}

interface ModLoadState {
  data: ModLoadData;
}

const initialState: ModLoadState = {
  data: {
    gdam: [],
    dam: [],
    demand: [],
    rtm: [],
    dailyAverage: [],
  },
};

const modLoadSlice = createSlice({
  name: "modLoad",
  initialState,
  reducers: {
    ModLoadDataUpdate: (
      state,
      action: PayloadAction<{ type: keyof ModLoadData; data: any[] }>
    ) => {
      state.data[action.payload.type] = action.payload.data;
    },
  },
});

export const { ModLoadDataUpdate } = modLoadSlice.actions;
export default modLoadSlice.reducer;
